import React, { useState } from "react"
import { Modal, ModalBody, SIZE, ROLE, ModalFooter } from "baseui/modal"
import useEditorType from "~/hooks/useEditorType"
import { Block } from "baseui/block"
import { useEditor } from "@layerhub-io/react"
import { Button } from "baseui/button"
import Cropper from 'react-easy-crop'
import useDesignEditorContext from "~/hooks/useDesignEditorContext"
import Loading from "~/components/Loading"
import useAppContext from "~/hooks/useAppContext"


interface ComponentProps {
  isOpen: boolean
  setIsOpen: (v: boolean) => void
}
export default function ({ isOpen, setIsOpen }: ComponentProps) {
  const { cropImage } = useDesignEditorContext()
  const editor = useEditor()

  const aspectRatio = (cropImage.width * cropImage.scaleX) / (cropImage.height * cropImage.scaleY);
  const imageUrl = cropImage.metadata.originalImageUrl;

  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
  const [loading, setLoading] = useState(false)

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels)
  }

  const cropComplete = async () => {
    setLoading(true);
    try {
      if (!editor || !cropImage || !imageUrl || !croppedAreaPixels) {
        return;
      }

      const originalRenderedWidth = cropImage.width * (cropImage.scaleX || 1);
      const originalRenderedHeight = cropImage.height * (cropImage.scaleY || 1);
      const originalLeft = cropImage.left;
      const originalTop = cropImage.top;

      cropImage.setSrc(
        imageUrl,
        () => {
          cropImage.set({
            left: originalLeft,
            top: originalTop,
            cropX: croppedAreaPixels.x,
            cropY: croppedAreaPixels.y,
            width: croppedAreaPixels.width,
            height: croppedAreaPixels.height,
            scaleX: originalRenderedWidth / croppedAreaPixels.width,
            scaleY: originalRenderedHeight / croppedAreaPixels.height,
          }).setCoords();

          cropImage.metadata = {
            ...cropImage.metadata,
            originalImageUrl: imageUrl,
          };

          editor.canvas.requestRenderAll();
          editor.history.save();
          setIsOpen(false);
          setLoading(false);
        },
        { crossOrigin: "anonymous" }
      );
    } catch (error) {
      console.error("Error applying crop:", error);
      setLoading(false);
    }
  };
  


  return (
    <Modal
        onClose={() => setIsOpen(false)}
        closeable={loading ? false : true}
        isOpen={isOpen}
        animate
        autoFocus
        size={"auto"}
        role={ROLE.dialog}
        overrides={{
          Dialog: {
            style: {
              borderTopRightRadius: "8px",
              borderEndStartRadius: "8px",
              borderEndEndRadius: "8px",
              borderStartEndRadius: "8px",
              borderStartStartRadius: "8px",
            },
          },
        }}
      >
        <Block >

          {
            loading ?
            <Block $style={{
              width: "20vw", 
              height: "20vh", 
              maxWidth: "20vh",
              maxHeight: "20vh",
              overflow: "hidden",
              position: "relative"
          }}>
             <Loading /> 
            </Block>:
            <Block $style={{
              width: "60vw", 
              height: "60vh", 
              maxWidth: "60vh",
              maxHeight: "60vh",
              overflow: "hidden",
              position: "relative"
          }}>
            <Cropper
              image={imageUrl}
              crop={crop}
              zoom={zoom}
              aspect={aspectRatio}
              onCropChange={setCrop}
              onCropComplete={onCropComplete}
              onZoomChange={setZoom}
              />

          </Block>
          }
          
        </Block>
        
        {
          loading ? null :
          <ModalFooter>
        <Block $style={{ display: "flex", alignItems: "center", justifyContent: "center", paddingBottom: "2rem", paddingTop: "2rem" }}>
            <Button onClick={cropComplete} style={{ width: "190px" }}>
                Crop
            </Button>
        </Block>
        </ModalFooter>
        }
        
      </Modal>
  )
}
